import { render, staticRenderFns } from "./ExtraButtons.vue?vue&type=template&id=bfa8fc7e&"
import script from "./ExtraButtons.vue?vue&type=script&lang=ts&"
export * from "./ExtraButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfa8fc7e')) {
      api.createRecord('bfa8fc7e', component.options)
    } else {
      api.reload('bfa8fc7e', component.options)
    }
    module.hot.accept("./ExtraButtons.vue?vue&type=template&id=bfa8fc7e&", function () {
      api.rerender('bfa8fc7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/ExtraButtons.vue"
export default component.exports